import React from 'react'
import styles from "./WidgetGroup.module.scss";

const WidgetGroup = ({children}) => {
  return (
    <div className={styles.root}>
      {children}
    </div>
  )
}

export default WidgetGroup